"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapRegisterMessage = mapRegisterMessage;
/** Human-readable `mc` (registration) status messages — Android N0.e / AbstractC0136h (25453). */
function mapRegisterMessage(status, serverText) {
    if (status === 0)
        return 'Регистрация успешна';
    if (status === 3)
        return serverText?.trim() || 'IP в чёрном списке';
    if (status === 4)
        return 'Логин короче 3 символов';
    if (status === 5)
        return 'Логин длиннее 255 символов';
    if (status === 6)
        return 'Логин занят';
    if (status === 7)
        return serverText?.trim() || 'Логин в чёрном списке';
    if (status === 8)
        return 'Неправильный email';
    if (status === 9)
        return 'Email занят';
    if (status === 10)
        return 'Email в чёрном списке';
    if (status === 11)
        return 'Слишком короткий пароль';
    if (status === 12)
        return 'Введите код с картинки';
    return `Ошибка регистрации (код ${status})`;
}
